<template>
    <div>
        <div class="matters-box">
            <p class="title-line">便民应用</p>
            <ul>
<!--                <router-link tag="li" to="" @click.native="goFzzxHref">-->
<!--                    <img src="~@public/img/hotApply/icon_fzzx.png" alt="湖北省反诈中心">-->
<!--                    <p>湖北省反诈中心</p>-->
<!--                </router-link>-->

                <router-link tag="li" to="" @click.native="openQrsearch">
                    <img src="~@public/img/newIndex/icon_app_010.png" alt="证照核验">
                    <p>证照核验</p>
                </router-link>
                <router-link tag="li" to="/user/my-tolerance">
                    <img src="~@public/img/newIndex/icon_app_13.png" alt="容缺受理">
                    <p>容缺受理</p>
                </router-link>
                <router-link tag="li" to="/lostFoundList">
                    <img src="~@public/img/hotApply/icon_swzl.png" alt="失物招领">
                    <p>失物招领</p>
                </router-link>
                <router-link tag="li" to="/moveCar">
                    <img src="~@public/img/hotApply/icon_dlyc.png" alt="堵路移车">
                    <p>堵路移车</p>
                </router-link>
                <router-link tag="li" to="/searchNoticesList">
                    <img src="~@public/img/hotApply/icon_xrxq.png" alt="寻人寻亲">
                    <p>寻人寻亲</p>
                </router-link>
                <router-link tag="li" to="" @click.native="login122('p00000000000000000005')">
                    <img src="~@public/img/hotApply/icon_wfcl.png" alt="交通违法处理">
                    <p>交通违法处理</p>
                </router-link>
<!--                <router-link tag="li" to="/clueReport">-->
<!--                    <img src="~@public/img/hotApply/icon_wfjb.png" alt="投诉">-->
<!--                    <p>投诉"指尖上的形式主义"</p>-->
<!--                </router-link>-->
                <router-link tag="li" to="" @click.native="login122('p00000000000000000014')">
                    <img src="~@public/img/hotApply/icon_wfjf.png" alt="交通违法缴费">
                    <p>交通违法缴费</p>
                </router-link>
                <router-link tag="li" to="" @click.native="login122('p00000000000000000005')">
                    <img src="~@public/img/hotApply/icon_fxcwfcx.png" alt="非现场违法查询">
                    <p>非现场违法查询</p>
                </router-link>
                <router-link tag="li" to="" @click.native="login122('p00000000000000000024')">
                    <img src="~@public/img/hotApply/icon_kckp.png" alt="快撤理赔">
                    <p>快撤理赔</p>
                </router-link>
                <router-link tag="li" to="" @click.native="login122('p00000000000000000025')">
                    <img src="~@public/img/hotApply/icon_lnmj.png" alt="六年免检">
                    <p>六年免检</p>
                </router-link>
                <router-link tag="li" to="/wechatTrain">
                    <img src="~@public/img/newIndex/icon_app_14.png" alt="微信直通车">
                    <p>微信直通车</p>
                </router-link>
                <router-link tag="li" @click.native="toUrl('/easyLock')" to="">
                    <img src="~@public/img/newIndex/icon_app_12.png" alt="便民开锁">
                    <p>便民开锁</p>
                </router-link>
                <router-link tag="li" @click.native="toUrl('sealManagement')" to="">
                    <img src="~@public/img/newIndex/icon_app_15.png" alt="印章管理平台">
                    <p>印章管理平台</p>
                </router-link>
<!--                <router-link tag="li" @click.native="toUrl('PoliceMap')" to="">-->
<!--                    <img src="~@public/img/hotApply/icon_sbjj.png" alt="身边警局">-->
<!--                    <p>身边警局</p>-->
<!--                </router-link>-->
                <router-link tag="li" to="ridingRecord">
                    <img  src="~@public/img/hotApply/icon_dlyc.png" alt="乘车报备">
                    <p>乘车报备</p>
                </router-link>
                <router-link tag="li" @click.native="toUrl('HuberMap')" to="">
                    <img src="~@public/img/hotApply/icon_hbsc.png" alt="湖北社采">
                    <p>湖北社采</p>
                </router-link>

<!--                <router-link tag="li" to="" @click.native="goSsHref">-->
<!--                    <img src="~@public/img/hotApply/icon_ssp.png" alt="随手拍">-->
<!--                    <p>交警随手拍</p>-->
<!--                </router-link>-->
<!--                <router-link tag="li" @click.native="toUrl('eHp')" to="">-->
<!--                    <img src="~@public/img/hotApply/icon_ssp.png" alt="鄂汇拍">-->
<!--                    <p>鄂汇拍</p>-->
<!--                </router-link>-->

                <!--            <router-link tag="li" to="/ridingRecord">-->
                <!--                <img src="~@public/img/newIndex/icon_app_08.png" alt="乘车备案处理">-->
                <!--                <p>乘车备案处理</p>-->
                <!--                <span>乘车备案处理</span>-->
                <!--            </router-link>-->
<!--                <router-link tag="li" to="/complaint">-->
<!--                    <img src="~@public/img/hotApply/icon_wfjb.png" alt="12389投诉">-->
<!--                    <p>12389投诉</p>-->
<!--                </router-link>-->
            </ul>
        </div>
        <div class="matters-box">
            <p class="title-line">便民查询</p>
            <ul>
<!--                <router-link tag="li" to="/birth">-->
<!--                    <img src="~@public/img/hotApply/icon_sfzbljdcx.png" alt="新生儿出生医学证明查询">-->
<!--                    <p>新生儿出生医学证明查询</p>-->
<!--                </router-link>-->
<!--                <router-link tag="li" to="/funeral">-->
<!--                    <img src="~@public/img/hotApply/icon_cmcx.png" alt="居民殡葬火化信息查询">-->
<!--                    <p>居民殡葬火化信息查询</p>-->
<!--                </router-link>-->

<!--                <router-link tag="li" to="/inoculate">-->
<!--                    <img src="~@public/img/hotApply/icon_qsgxzm.png" alt="新冠疫苗接种信息查询">-->
<!--                    <p>新冠疫苗接种信息查询</p>-->
<!--                </router-link>-->

<!--                <router-link tag="li" to="/birthDate">-->
<!--                    <img src="~@public/img/hotApply/icon_hkbljdcx.png" alt="新生儿出生日期查询">-->
<!--                    <p>新生儿出生日期查询</p>-->
<!--                </router-link>-->

                <router-link tag="li" to="/idQuery">
<!--                <router-link tag="li" to="" @click.native="jzz()">-->
                    <img src="~@public/img/hotApply/icon_sfzbljdcx.png" alt="身份证办理进度查询">
                    <p>身份证办理进度查询</p>
                </router-link>
<!--                <router-link tag="li" to="/resquery">-->
                <router-link tag="li" to="" @click.native="jzz()">
                    <img src="~@public/img/hotApply/icon_jzzbljd.png" alt="居住证办理进度查询">
                    <p>居住证办理进度查询</p>
                </router-link>
<!--                <router-link tag="li" to="/household">-->
                <router-link tag="li" to="" @click.native="jzz()">
                    <img src="~@public/img/hotApply/icon_hkbljdcx.png" alt="户口办理进度查询">
                    <p>户口办理进度查询</p>
                </router-link>
<!--                <router-link tag="li" to="/entry-exit">-->
<!--                    <img src="~@public/img/hotApply/icon_crjbljdcx.png" alt="出入境办理进度查询">-->
<!--                    <p>出入境办理进度查询</p>-->
<!--                </router-link>-->
<!--                <router-link tag="li" to="/registration">-->
<!--                    <img src="~@public/img/hotApply/icon_qsgxzm.png" alt="涉外婚姻登记信息核验服务">-->
<!--                    <p>涉外婚姻登记信息核验服务</p>-->
<!--                </router-link>-->
                <router-link tag="li" to="/eMSQuery">
                    <img src="~@public/img/hotApply/icon_emscx.png" alt="EMS查询">
                    <p>EMS查询</p>
                </router-link>
                <router-link tag="li" to="/renameQuery">
                    <img src="~@public/img/hotApply/icon_cmcx.png" alt="重名查询">
                    <p>重名查询</p>
                </router-link>

<!--                <router-link tag="li" to="#" @click.native="link('1')">-->
<!--                    <img src="~@public/img/hotApply/icon_crjqzcx.png" alt="出入境签注查询">-->
<!--                    <p>出入境签注查询</p>-->
<!--                </router-link>-->
<!--                <router-link tag="li" to="" @click.native="goHref">-->
<!--                    <img src="~@public/img/hotApply/icon_crjjlcx.png" alt="出入境记录查询">-->
<!--                    <p>出入境记录查询</p>-->
<!--                </router-link>-->
<!--                <router-link tag="li" to="#" @click.native="link('3')">-->
<!--                    <img src="~@public/img/hotApply/icon_crjzjcx.png" alt="出入境证件查询">-->
<!--                    <p>出入境证件查询</p>-->
<!--                </router-link>-->
                <router-link tag="li" to="/contactQuery" >
                    <img src="~@public/img/hotApply/icon_zgzwsglxfs.png" alt="中国驻外使馆联系方式查询">
                    <p>中国驻外使馆联系方式查询</p>
                </router-link>
                <router-link tag="li" to="/licenseQuery">
                    <img src="~@public/img/hotApply/icon_jszjfcx.png" alt="驾驶证记分查询">
                    <p>驾驶证记分查询</p>
                </router-link>
                <router-link tag="li" to="/lllegalQuery">
                    <img src="~@public/img/hotApply/icon_jdcwfcx.png" alt="机动车违法查询">
                    <p>机动车违法查询</p>
                </router-link>
                <router-link tag="li" to="/sealquery">
                    <img src="~@public/img/hotApply/icon_gzkzdwmlcx.png" alt="公章刻制单位名录查询">
                    <p>公章刻制单位名录查询</p>
                </router-link>
                <router-link tag="li" to="/unlockQuery">
                    <img src="~@public/img/hotApply/icon_ksdwrymlcx.png" alt="开锁单位/人员名录查询">
                    <p>开锁单位/人员名录查询</p>
                </router-link>
<!--                <router-link tag="li" to="/permitQuery">-->
<!--                    <img src="~@public/img/hotApply/icon_gajzzbljdcx.png" alt="港澳居住证办证进度查询">-->
<!--                    <p>	港澳居住证办证进度查询</p>-->
<!--                </router-link>-->
<!--                <router-link tag="li" to="/TWQuery">-->
<!--                    <img src="~@public/img/hotApply/icon_gatjmjzzsldcx.png" alt="台湾居住证办证进度查询">-->
<!--                    <p>	台湾居住证办证进度查询</p>-->
<!--                </router-link>-->
                <router-link tag="li" to="/differentQuery">
                    <img src="~@public/img/hotApply/icon_qgydzcx.png" alt="全国异地证办证进度查询">
                    <p>全国异地证办证进度查询</p>
                </router-link>
                <router-link tag="li" to="/rareQuery">
<!--                <router-link tag="li" to="" @click.native="jzz()">-->
                    <img src="~@public/img/hotApply/icon_cmcx.png" alt="生僻字查询">
                    <p>生僻字查询</p>
                </router-link>
<!--                <router-link tag="li" to="/resigQuery">-->
<!--                    <img class="gray" src="~@public/img/hotApply/icon_jzdjztcx.png" alt="居住登记状态查询">-->
<!--                    <p>居住登记状态查询</p>-->
<!--                </router-link>-->
<!--                <router-link tag="li" to="/acceptanceQuery">-->
<!--                    <img src="~@public/img/hotApply/icon_gatjmjzzsldcx.png" alt="港澳台居民居住证受理点查询">-->
<!--                    <p>港澳台居民居住证受理点查询</p>-->
<!--                </router-link>-->
<!--                <router-link tag="li" to="/polinfoquery">-->
<!--                    <img src="~@public/img/newIndex/icon_yw_07.png" alt="警情信息查询">-->
<!--                    <p>警情信息查询</p>-->
<!--                </router-link>-->
                <router-link tag="li" to="" @click.native="goHref">
                    <img src="~@public/img/hotApply/zhifagk.png" alt="执法公开">
                    <p>执法公开查询</p>
                </router-link>
            </ul>
        </div>
        <div class="matters-box">
            <p class="title-line">证明开具</p>
            <ul>
                <router-link tag="li" @click.native="toUrl('rideCertificate')" to="">
                    <img src="~@public/img/newIndex/icon_app_11.png" alt="电子乘机证明">
                    <p>电子乘机证明</p>
                </router-link>
                <router-link tag="li" to="/matterGuide/1/5d1b8b6fe01d4215be2566066f4f440b">
                    <img src="~@public/img/hotApply/icon_qsgxzm.png" alt="亲属关系证明">
                    <p>亲属关系证明</p>
                </router-link>
                <router-link tag="li" to="/matterGuide/1/f78f0229c8c74b3981a9af39869c5417">
                    <img src="~@public/img/hotApply/icon_hkzxzm.png" alt="注销户口证明">
                    <p>注销户口证明</p>
                </router-link>
<!--                <router-link tag="li" to="" @click.native="notOpen">-->
<!--                    <img src="~@public/img/hotApply/icon_fzcsmzm.png" alt="非正常死亡证明">-->
<!--                    <p>非正常死亡证明</p>-->
<!--                </router-link>-->
<!--                <router-link tag="li" to="" @click.native="notOpen">-->
<!--                    <img src="~@public/img/hotApply/icon_wfzjlzm.png" alt="无犯罪记录证明">-->
<!--                    <p>无犯罪记录证明</p>-->
<!--                </router-link>-->
                <router-link tag="li" to="/matterGuide/1/9dcd154baafe425ea2b723cac9e3dcb6">
                    <img src="~@public/img/hotApply/icon_wfzjlzm.png" alt="异常户口注销证明">
                    <p>异常户口注销(删除)证明</p>
                </router-link>
                <router-link tag="li" to="/matterGuide/1/e2dd931783b84c44a6d3db72864996af">
                    <img src="~@public/img/hotApply/icon_hkbljdcx.png" alt="户口登记项目变更证明">
                    <p>户口登记项目变更更正证明</p>
                </router-link>
<!--                <router-link tag="li" to="">-->
<!--                    <img class="gray" src="~@public/img/hotApply/icon_lssfzm.png" alt="临时身份证明">-->
<!--                    <p>临时身份证明</p>-->
<!--                </router-link>-->
            </ul>
        </div>
<!--        <div class="matters-box">-->
<!--            <p class="title-line">证照核验</p>-->
<!--            <ul>-->
<!--                <router-link tag="li" to="/qrsearch">-->
<!--                    <img src="~@public/img/hotApply/icon_qsgxzm.png" alt="亲属关系证明">-->
<!--                    <p>扫一扫</p>-->
<!--                </router-link>-->
<!--            </ul>-->
<!--        </div>-->
    </div>
</template>

<script>
    import { Dialog, Toast } from 'vant'
    import {memberApi} from '@/api/member'
    import { Source } from '@/utils/source'
    import Bridge from '@/utils/bridge'

    export default {
        components: {
            [Dialog.Component.name]: Dialog.Component
        },
        data() {
            return {}
        },
        methods:{
            goHref() {
            //     if (this.$cookie.getUser() && this.$cookie.getUser().guid) {
            //         window.location.href = 'http://gat.hubei.gov.cn/zfgk-vx/'
                    window.location.href = 'http://223.76.234.78:9999/zfgk-vx/'
            //     } else {
            //         this.$router.push('/login')
            //     }
            //     // window.location.href = 'http://gat.hubei.gov.cn/zfgk-vx/'
            },
            goSsHref() {
                window.location.href = 'https://cloud-4ga5tibs44b35540-1256139749.tcloudbaseapp.com/'
            },

            goFzzxHref() {
                window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI0MDUxNTI3Mg==#wechat_redirect'
            },
            link(val) {
                if(val==='1'){
                    this.$router.push("/endorsement")
                }else if(val==='3'){
                    this.$router.push("/exitdocuments")
                }else{
                    window.location.href = 'https://s.nia.gov.cn/mps/main.html';
                }

            },
            notOpen() {
                Dialog.alert({
                    message: '该服务正在建设中，敬请期待'
                }).then(() => {
                    // on close
                });
            },
            /**
             * 微信二维码扫一扫
             */
            openQrsearch() {
                let source = Source.getSource()
                if(source === 'IOS') {
                    // 调用ios扫描二维码
                    Bridge.callhandler('goNewVC', { "newPath": '', "newVC": "scan" }, (data) => {
                    });
                } else if (source === 'ANDROID') {
                    // 调用安卓扫描二维码
                    window.android.scanQR()
                } else {
                    wx.scanQRCode({
                        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                        scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
                        success: (res) => {
                            //如果有其他的证照类型多写几个else if，无犯罪记录证明没有种类
                            if ((res.resultStr).length == 32) {
                                this.$router.push("/qrCriminalRecord/" +res.resultStr)
                            }else{
                                let result = JSON.parse(res.resultStr);
                                if (result.type == '08') {
                                    this.$router.push("/qridcard/" + result.token);
                                }
                                if (result.type == '06') {
                                    this.$router.push("/qrdriverLicense/" + result.token);
                                }
                                if (result.type == '09') {
                                    this.$router.push("/whResidencePermit/" + result.token);
                                }
                            }
                            // window.location.href = result;
                        }
                    });
                }
            },

            jzz() {
                Toast.fail('功能服务维护中，暂停使用！！！')
            },
            /**
             * 制证中心单点
             */
            async zzzxLogin() {
                if (this.$cookie.getUser() && this.$cookie.getUser().guid) {
                    try {
                        const guid = this.$cookie.getUser().guid;
                        const res = await this.$httpUtils.getGatewayUtils(`/member/hubei/public/automat/${guid}`)
                        console.log(res)
                        if (res.data.succ) {
                            window.location.href = 'https://wx.gckjwh.com:38081/?token='+res.data.data
                        } else {
                            Toast.fail('系统异常，请联系管理员')
                        }
                    } catch (error) {
                        Toast.fail('服务器运行失败，请稍后再试。')
                        console.log(error)
                    }
                } else {
                    this.$router.push('/login')
                }
            },

            /**
             * 122单点
             */
            login122(productId) {
                if (this.$cookie.getUser() && this.$cookie.getUser().guid) {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '加载中...'
                    })
                    let url = memberApi.login122 + '?productId=' + productId;
                    this.$httpUtils.getGatewayUtils(url).then((res) => {
                        if (res.data && res.data.succ) {
                            Toast.clear()
                            window.location.href = res.data.data;
                        } else {
                            Toast.clear()
                            Dialog.alert({
                                message: '该服务正在建设中，敬请期待'
                            }).then(() => {
                                // on close
                            });
                        }
                    }).catch((err) => {
                        console.log(err)
                        Toast.fail('服务异常')
                    });
                } else {
                    this.$router.push('/login')
                }
            },
            // 几个长按二维码扫描的功能
            toUrl(url) {
                let source = Source.getSource()
                if (source !== 'WEI') {
                    Toast('请在微信端打开！')
                    return false
                }
                this.$router.push(url)
            }
        }
    }
</script>

<style lang="less" scoped>
    .matters-box {
        padding: .33rem .24rem 0;
        background: #fff;
        border-bottom: .11rem solid #f4f6f8;

    .title-line {
        position: relative;
        padding-left: .2rem;
        margin-bottom: .36rem;
        font-weight: 500;
        font-size: .32rem;
        color: #222;
    }

    .title-line:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: .06rem;
        height: 80%;
        background: #1349DD;

    }

    ul {
        display: flex;
        flex-wrap: wrap;
        padding: 0 .35rem;

    li {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 1.65rem;
        margin: 0 .7rem .48rem 0;
        text-align: center;

    img {
        width: .71rem;
        height: .71rem;
        margin-bottom:.22rem;
    }
    img.gray {
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);

        filter: grayscale(100%);

        filter: gray;
    }
    p {
        font-size: .28rem;
        color: #222;
    }

    }
    li:nth-of-type(4n) {
        margin-right: 0;
    }

    }
    }
</style>
